import {DialogTitle} from '@mui/material';
import styled from 'styled-components';
export const StyledDialogTitle = styled(DialogTitle)`
    margin: 0;
    padding: 16px !important;
    @media (max-width: 600px) {
        font-size: 1rem !important;
    },
`;
